interface HasPathname {
  pathname: string;
}

export function targetView(location: HasPathname = window.location) {
  // Validate if the Target Libraries are available on your website
  if (window.adobe !== undefined && window.adobe.target && typeof window.adobe.target.triggerView === 'function') {
    window.adobe.target.triggerView(createNameFromPath(location.pathname));
  }
}

function createNameFromPath(path: string) {
  if (path === '/') {
    return 'Home';
  }
  let viewName = path;

  if (viewName.startsWith('/')) {
    viewName = viewName.substr(1);
  }
  return viewName.replace(/\//g, '-');
}
